import MagicEditor from "components/layout/MagicEditor";
import { Button, Dialog, Tooltip } from "components/ui";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { HiOutlinePencil } from "react-icons/hi2";
import { TbPencilStar, TbTrash } from "react-icons/tb";
import { getFileTypeImageVideo } from "utils/fileType";
import useEditorCallback from "utils/hooks/useEditorCallback";
import MagicEditButton from "./MagicEditButton";
import { PLACEMENT } from "components/ui/utils/constant";
import FullscreenMediaViewer from "components/shared/FullscreenMediaViewer";

const MediaPreview = ({
    asset,
    network,
    isEditable = false,
    className = "",
    parentClassName = "",
    onAssetDelete = undefined,
    onAssetEdit = undefined,
    onAssetNew = undefined,
    buttonsPlacement = "bottom-end",
    videoControls = true,
}) => {

    const [ mediaExpanded, setMediaExpanded ] = useState("");

    const original = asset?.video?.url || asset?.image?.url;
    const thumbnail = asset?.image?.thumbnail?.url || asset?.image?.url;
    const type = !!asset?.video?.url || !!asset?.image?.url 
        ? !!asset?.video?.url 
            ? "video" 
            : "image"
        : getFileTypeImageVideo(original);

    return (<>
        <span className={`relative group block w-full h-full ${!asset ? `invisible` : ``} ${parentClassName}`}>
            {type == "image" && <>
                <img 
                    onClick={() => setMediaExpanded(original)} 
                    src={thumbnail} 
                    className={`transition-all hover:opacity-[0.95] cursor-pointer lg:[.fullScreen_&]:!hidden ${className}`} 
                />
                <img 
                    onClick={() => setMediaExpanded(original)} 
                    src={original || thumbnail} 
                    className={`transition-all hover:opacity-[0.95] cursor-pointer !hidden lg:[.fullScreen_&]:!block ${className}`} 
                />
            </>}
            {type == "video" && 
                <video 
                    onClick={() => setMediaExpanded(original)} 
                    src={original} 
                    preload="metadata" 
                    muted={true}
                    autoPlay={true} 
                    controls={videoControls} 
                    loop={true} 
                    className={`transition-all hover:opacity-[0.95] cursor-pointer ${className}`} 
                    onError={(e) => {
                        if (asset?.video?.thumbnail?.url && asset?.video?.thumbnail?.type === 'image') {
                            const imgElement = document.createElement('img');
                            imgElement.src = asset.video.thumbnail.url;
                            imgElement.className = e.target.className;
                            imgElement.onclick = () => setMediaExpanded(asset.video.thumbnail.url);
                            e.target.parentNode.replaceChild(imgElement, e.target);
                        }
                    }}
                />
            }

            {isEditable && 
                <div className={`absolute flex items-center gap-2 lg:opacity-0 transition-all pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto ${buttonsPlacement == "bottom-end" ? `bottom-3 right-3` : buttonsPlacement == "top-end" ? `top-3 right-3` : `bottom-3 right-3`}`}> 
                    <Button
                        shape="round"
                        variant="twoTone"
                        size="sm"
                        color="red-600"
                        className="!rounded-xl"
                        onClick={() => onAssetDelete()}
                        icon={<TbTrash />}
                    />
                    <MagicEditButton 
                        asset={asset}
                        onAssetEdit={onAssetEdit}
                        placement={buttonsPlacement == "top-end" ? PLACEMENT.BOTTOM_END : undefined}
                        isPostPreview={true}
                    />
                </div>
            }
        </span>

        <FullscreenMediaViewer
            open={!!mediaExpanded}
            src={mediaExpanded}
            type={type}
            onClose={() => setMediaExpanded("")}
        />
    </>);
}

export default MediaPreview;